
export default function GoogleError() {
  return (
    <>
      <div
        className="container text-center"
        style={{display:"flex",justifyContent:"center"}}
      >
        <div style={{background:"white",textAlign: "center",marginTop:"15%",marginBottom: "25%",width:"40%",padding:"30px",boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)"}}>
          <h1>An Error Occurred</h1>
          <p>We are unable to sign you in with Google SSO.</p>
          <p>
            Questions? Contact us at{" "}
            <email style={{color: "blueviolet",fontFamily: "emoji"}}>
              support@digitalmain.com
            </email>
          </p>
        </div>
      </div>
    </>
  );
}
